export function useTruncateText() {
  const truncateText = (text: string, maxLength: number, addEllipsis: boolean = true): string => {
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength) + (addEllipsis ? ' ...' : '');
  };

  return { truncateText };
}
